var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1714 0C16.7336 0 18 1.23122 18 2.75C18 4.26878 16.7336 5.5 15.1714 5.5C14.298 5.5 13.5176 5.11461 12.9988 4.50977L5.50246 8.61035C5.60076 8.88969 5.65714 9.18828 5.65714 9.5C5.65714 9.81107 5.60036 10.1089 5.50246 10.3877L12.9998 14.4883C13.5186 13.8844 14.2988 13.5 15.1714 13.5C16.7336 13.5 18 14.7312 18 16.25C18 17.7688 16.7336 19 15.1714 19C13.6093 19 12.3429 17.7688 12.3429 16.25C12.3429 15.9384 12.3983 15.6396 12.4965 15.3604L5.00022 11.2598C4.48136 11.8643 3.70178 12.25 2.82857 12.25C1.26639 12.25 0 11.0188 0 9.5C0 7.98122 1.26639 6.75 2.82857 6.75C3.70099 6.75 4.48035 7.13465 4.99922 7.73828L12.4965 3.6377C12.3987 3.35895 12.3429 3.06096 12.3429 2.75C12.3429 1.23122 13.6093 0 15.1714 0ZM15.1714 14.5C14.1773 14.5 13.3714 15.2835 13.3714 16.25C13.3714 17.2165 14.1773 18 15.1714 18C16.1655 18 16.9714 17.2165 16.9714 16.25C16.9714 15.2835 16.1655 14.5 15.1714 14.5ZM2.82857 7.75C1.83446 7.75 1.02857 8.5335 1.02857 9.5C1.02857 10.4665 1.83446 11.25 2.82857 11.25C3.82268 11.25 4.62857 10.4665 4.62857 9.5C4.62857 8.5335 3.82268 7.75 2.82857 7.75ZM15.1714 1C14.1773 1 13.3714 1.7835 13.3714 2.75C13.3714 3.7165 14.1773 4.5 15.1714 4.5C16.1655 4.5 16.9714 3.7165 16.9714 2.75C16.9714 1.7835 16.1655 1 15.1714 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharing);
export default __webpack_public_path__ + "static/media/sharing.50d476192e16b2ce9ab117006ffd8362.svg";
export { ForwardRef as ReactComponent };